<template>
  <dam-layout>
    <base-heading>DAM: Portal page to be built</base-heading>
  </dam-layout>
</template>
<script>
import DamLayout from '../../layouts/DamLayout';
export default {
  name: 'PortalsEdit',
  components: {
    DamLayout,
  },
};
</script>
